import React, { FunctionComponent, ComponentProps, useMemo } from 'react';
import { IconDeprecated, IconType } from '../../misc/IconDeprecated/IconDeprecated';
import { prepareProps } from '../../utils/propUtils';
import { classes } from '../../utils/utils';
import styles from './PageContentHeader.module.css';
export type PageContentHeaderProps = ComponentProps<'header'> & {
  iconConfig: IconConfig;
  title: string;
  /**
   * return a React.JSX.Element for each section so a separator can be shown between multiple elements
   */
  renderRightContentElements?: () => Array<React.JSX.Element>;
  renderAdditionalBottomContent?: () => React.ReactNode;
};
export type IconConfig = {
  iconType: IconType;
  iconName: string;
};
export const PageContentHeader: FunctionComponent<PageContentHeaderProps> = React.memo(props => {
  const {
    title,
    iconConfig,
    renderRightContentElements,
    renderAdditionalBottomContent,
    className,
    ...remainingProps
  } = prepareProps({
    props,
    ignoreChildren: true
  });
  const renderedRightContent = useMemo(() => {
    const subElements = renderRightContentElements?.() ?? [];
    return <>
          {subElements.map((se, index) => <div
      // eslint-disable-next-line react/no-array-index-key
      key={index} className={styles.rightContentElement}>
              {se}
            </div>)}
        </>;
  }, [renderRightContentElements]);
  const additionalBottomContent = renderAdditionalBottomContent?.();
  const hasAdditionalBottomContent = React.Children.count(additionalBottomContent) > 0;
  return <header {...remainingProps} className={classes(className, styles.header)}>
        <div className={styles.mainRow}>
          <div className={styles.leftContent}>
            <IconDeprecated type={iconConfig.iconType} name={iconConfig.iconName}></IconDeprecated>
            <div className={styles.title} data-testid="PageContentHeader.Title">
              {title}
            </div>
          </div>
          {renderedRightContent}
        </div>

        {hasAdditionalBottomContent ? <div className={styles.additionalBottomContent}>
            {additionalBottomContent}
          </div> : null}
      </header>;
});